// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********************************************
Colors
***********************************************/
/***** Brand *****/
:root {
  /* Infinity brand colors */
  --color-brand: #e73389;
  --color-brand-dark: #af2769;
  --color-brand-light: #f29dc3;
  --color-brand-picker: #e73389;
  /* Infinity brand colors */
  --color-headerBg: #0a3749;
  --color-headerTxt: #ffffff;
  /* Infinity playback colors */
  --color-brandPlyr: #e73389;
  --color-brand-darkPlyr: #af2769;
  --color-brand-lightPlyr: #f29dc3;
  font-size: 14px;
}

/***** Infinity *****/
/***** Positive *****/
/***** Warning *****/
/***** Negative *****/
/***** Information *****/
/***** Royal *****/
/***** Sun *****/
/***** Slates *****/
/*slate*/
/*stone*/
/*silver*/
/***** Blacks *****/
/*black*/
/***** Grays *****/
/***** Brand greyout set *****/
/***** Brand greyout set *****/
.checkbox-group {
  max-height: 20rem;
  overflow: scroll;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
